import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { competitorOffersQueryKeys } from './competitorOffersQueryKeys';

export function useGetCompetitorProperties() {
  return useQuery({
    queryKey: competitorOffersQueryKeys.properties(),
    queryFn: async ({ signal }) => (await PriceParrotService.getCompetitorProperties(signal)).data,
  });
}
